const CONFIG = {
  /**
   * Minimum version of GVL to resurface the banner
   */
  MINIMUM_GVL_VERSION: 98,
  /**
   * Setting this date will force the banner to resurface
   *
   * Currently set to Tuesday, 13 Jul 2021 11:00:00 UTC+2h in milliseconds
   */
  EARLIEST_VALID_DATE: 1626166800000,
  /**
   * This delay is used to allow the css to animate before removing
   * the cookie consent banner from the DOM
   */
  BANNER_REMOVAL_DELAY: 250,
  /**
   * Consent page url to redirect to for managing consent preferences
   */
  CONSENT_PAGE_URL: '/consent',
  /**
   * If the GA library is not available we will wait
   * for this time period before retrying
   */
  LOG_GA_EVENT_RETRY_TIMEOUT: 500,
  /**
   * Retry for a maximum of 10 times
   */
  LOG_GA_EVENT_RETRY_CAP: 10,
};

export default CONFIG;
